import React from 'react';
import { Link, Tooltip, VStack } from '@chakra-ui/react';
import { PhoneIcon } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { brand, whatsappHref } from '../data/brand';
const buttonStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  w: {
    base: '3.25rem',
    md: '3.5rem'
  },
  h: {
    base: '3.25rem',
    md: '3.5rem'
  },
  borderRadius: 'full',
  color: 'white',
  boxShadow: '0 8px 22px rgba(13,6,19,0.35)',
  transition: 'transform 0.2s ease, filter 0.2s ease',
  _hover: {
    textDecoration: 'none',
    transform: 'translateY(-2px)',
    filter: 'brightness(1.08)'
  }
};
export function FloatingCta() {
  return <VStack position="fixed" left={{
    base: 3,
    md: 5
  }} bottom={{
    base: 4,
    md: 6
  }} pb="env(safe-area-inset-bottom)" spacing={3} zIndex={30} data-id="element-76" data-mp="gnstbpojjks6">
      <Tooltip label={`Llamar ${brand.phone}`} placement="right" hasArrow data-id="element-77" data-mp="197hn52x2za7t">
        <Link href={brand.phoneHref} aria-label={`Llamar al ${brand.phone}`} bg="#1d74e8" {...buttonStyles} data-id="element-78" data-mp="14eeztciwcx02">
          <PhoneIcon size={24} aria-hidden="true" data-id="element-79" data-mp="2b3qnefzur92c" />
        </Link>
      </Tooltip>

      <Tooltip label="Escribir por WhatsApp" placement="right" hasArrow data-id="element-80" data-mp="2f2zcv8nv0ks3">
        <Link href={whatsappHref()} isExternal aria-label="Escribir por WhatsApp" bg="#25d366" {...buttonStyles} data-id="element-81" data-mp="21cvuwtw0jd8g">
          <WhatsAppIcon size={28} data-id="element-82" data-mp="269dy3pbp33io" />
        </Link>
      </Tooltip>
    </VStack>;
}